import type { UserBase } from '@awork/features/user/models/user.model.base'
import type { ProjectBase } from '@awork/features/project/models/project.model.base'
import type { TaskListBase } from '@awork/features/task/models/task-list.model.base'

export interface ParentTask {
  id: string
  name: string
}

export interface ITaskBase {
  id: string
  parentId?: string
  parent?: { name: string; id: string }
  parentTask?: ParentTask
  name: string
  assignees?: UserBase[]
  projectId?: string
  project?: ProjectBase
  startOn?: Date
  plannedDuration?: number
  dueOn?: Date
  laneOrder?: number
  autoLaneOrder?: number
  currentListId?: string // FE property meant to temporarily store list this instance of the task is in
  createdFromTaskId?: string
  createdOn?: Date
  updatedOn?: Date
  lists?: TaskListBase[]
  primaryTaskListId?: string
  deriveDatesFromSubtasks?: boolean
}

export class TaskBase implements ITaskBase {
  id: string
  parentId?: string
  parent?: { name: string; id: string }
  parentTask?: ParentTask
  name: string
  assignees?: UserBase[]
  projectId?: string
  project?: ProjectBase
  startOn?: Date
  plannedDuration?: number
  dueOn?: Date
  laneOrder?: number
  autoLaneOrder?: number
  currentListId?: string // FE property meant to temporarily store list this instance of the task is in
  createdFromTaskId?: string
  createdOn?: Date
  updatedOn?: Date
  lists?: TaskListBase[]
  primaryTaskListId?: string
  deriveDatesFromSubtasks?: boolean

  constructor(task: Partial<ITaskBase>) {
    Object.assign(this, task)

    if (this.startOn && !(this.startOn instanceof Date)) {
      this.startOn = new Date(this.startOn)
    }

    if (this.dueOn && !(this.endOn instanceof Date)) {
      this.dueOn = new Date(this.dueOn)
    }

    if (this.createdOn && !(this.createdOn instanceof Date)) {
      this.createdOn = new Date(this.createdOn)
    }

    if (this.updatedOn && !(this.updatedOn instanceof Date)) {
      this.updatedOn = new Date(this.updatedOn)
    }
  }

  get endOn(): Date {
    return this.dueOn ? new Date(this.dueOn) : undefined
  }

  set endOn(value: Date) {
    this.dueOn = value
  }
}
